import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../hooks/session';
import { schoolListState } from '../../common/atom';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
} from '../../common/helper';
import { getPortalMonthlyStatData } from '../../common/api/ApiPortal';
import { KEY_PORTAL_MONTHLY_STAT } from '../../common/key';

const DEFAULT_WIDTH = '8rem';
interface Props {
  tabValue: number;
  schoolClassInfo: any;
  setSchoolClassInfo: Dispatch<React.SetStateAction<any>>;
  onChangeTab?: (data: number) => void;
}

export const SwPortalStatTab: React.FC<Props> = ({
  tabValue,
  schoolClassInfo,
  setSchoolClassInfo,
  onChangeTab,
}) => {
  const navigate = useNavigate();
  const { loginVal } = useSession();
  const schoolList = useRecoilValue(schoolListState);
  const [schools, setSchools] = useState<any[]>([]);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(1);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [saveTabValue, setSaveTabValue] = useState<number>(tabValue);
  const [year, setYear] = useState<string>('');
  const [month, setMonth] = useState<string>('');
  const [reqRequest, setReqRequest] = useState<boolean>(false);

  const { refetch: refetchMonthlyStat } = useQuery(
    KEY_PORTAL_MONTHLY_STAT,
    () => {
      if (reqRequest) {
        const newData: any = {
          year: year,
          month: month,
        };
        return getPortalMonthlyStatData(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        console.log(res);
      },
      onError: e => {
        console.log(e);
      },
    }
  );

  const getMonthlyState = (newYear: string, newMonth: string) => {
    setYear(newYear);
    setMonth(newMonth);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSaveTabValue(newValue);

    switch (newValue) {
      case 0:
        navigate('/portalstat/portalclassrank');
        break;
      case 1:
        navigate('/portalstat/portalschoolrank');
        break;
      case 2:
        navigate('/portalstat/portaleducationofficerank');
        break;
      case 3:
        navigate('/portalstat/portalstatistics');
        break;
      case 4:
        navigate('/portalstat/portallogmanage');
        break;
      default:
        navigate('/portalstat');
    }
  };

  useEffect(() => {
    refetchMonthlyStat();
  }, [year, month]);

  useEffect(() => {
    setReqRequest(true);
  }, []);

  return (
    <Box>
      <Box
        className='flex_between'
        sx={{ mb: '2rem', borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs value={saveTabValue} onChange={handleChange}>
          <Tab label='학급별 랭킹' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='학교별 랭킹' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='지원청 랭킹' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='통계' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='로그(글) 관리' sx={{ width: DEFAULT_WIDTH }} />
        </Tabs>
        {/* <Box>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => getMonthlyState('2024', '06')}
          >
            6월 월간통계
          </Button>
          <Button
            sx={{ ml: '1rem' }}
            variant='outlined'
            color='primary'
            onClick={() => getMonthlyState('2024', '07')}
          >
            7월 월간통계
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
};
